import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './footer.component.scss',
})
export class FooterComponent {}
